/** 週活動在預約牌擺放中的合成 ID（負數，避開志工 -99999 與 VB 正整數） */
export const ACTIVITY_LAYOUT_BASE = 800000000;

export function activityToLayoutBookingId(activityId) {
  const n = Number(activityId);
  if (!Number.isFinite(n) || n <= 0) return null;
  return -(ACTIVITY_LAYOUT_BASE + Math.floor(n));
}

export function isActivityLayoutBooking(b) {
  if (b?.isActivity) return true;
  const n = Number(b?.ID ?? b);
  return Number.isFinite(n) && n <= -ACTIVITY_LAYOUT_BASE;
}

export function eventToLayoutBooking(ev) {
  const aid = ev?.id ?? ev?.ID;
  const ID = activityToLayoutBookingId(aid);
  if (ID == null) return null;
  const venue = String(ev.venue || ev.VENUE || '').trim();
  const start = String(ev.start_time || ev.ACTIVITY_TIME || '').trim();
  const range = String(ev.time_range || '').trim();
  const time = start || (range.split('~')[0] || '').trim();
  const name = String(ev.title || ev.NAME || '活動').trim() || '活動';
  return {
    ID,
    TYPE: '活動',
    CUSTOMER_NAME: name,
    PHONE: '',
    SEAT_NAME: venue || '活動',
    START_TIME: time,
    START_AT: null,
    NOTE: [range || time, venue].filter(Boolean).join('\n'),
    NUMBER: 1,
    STATUS: 'BOOKED',
    isActivity: true,
  };
}
